import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private pendingRequests = 0;
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  private readonly _isLoading = signal(false);
  readonly isLoading = this._isLoading.asReadonly();

  increment(): void {
    this.pendingRequests++;
    if (this.pendingRequests === 1 && !this.showTimer) {
      this.showTimer = setTimeout(() => {
        this.showTimer = null;
        if (this.pendingRequests > 0) {
          this._isLoading.set(true);
        }
      }, 200);
    }
  }

  decrement(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    if (this.pendingRequests === 0) {
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = null;
      }
      this._isLoading.set(false);
    }
  }
}
